export const LIMIT_STATE_APPROVED = "limitApproved";
export const LIMIT_STATE_IN_ACTIVE = "limitInActive";
export const LIMIT_STATE_DECLINED = "limitDeclined";
export const LIMIT_STATE_RESET_REQUIRED = "limitResetRequired";
export const LIMIT_STATE_DECLINED_SCORE = "limitDeclinedScore";
